import { useQuery } from "@tanstack/react-query";

import CustomTableService from "services/CustomTable";

// Custom tables whose relationship columns point at this record —
// RBAC-filtered server-side and limited to tables with linked rows.
// `linkedTabs` is [] until loaded; `isLoading` lets a detail page hold a
// deep link to a linked tab until the tabs arrive.
export function useLinkedTables(targetType, recordId) {
  const { data, isLoading } = useQuery({
    queryKey: [targetType, recordId, "linkedTables"],
    queryFn: () => CustomTableService.getLinkedTables(targetType, recordId),
    enabled: !!recordId,
  });
  return { linkedTabs: data?.tables ?? [], isLoading };
}
